import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';
import { ClientConfigStoreKey } from 'STORE/ClientConfig/ClientConfig';

export function handleAdminAuthUrlBase({ adminAuthUrlBase }: IClientConfigProperty): void {
  if (!adminAuthUrlBase) {
    return;
  }

  return Entities.clientConfig.setConfig(ClientConfigStoreKey.AdminAuthUrlBase, adminAuthUrlBase);
}
